module.exports = __webpack_public_path__ + "biggan-chinta-a520fec4a704cfc50011.svg";